export const httpCodes = {
   ok: 200,
   created: 201,
   accepted: 202,
   noContent: 204,
   resetContent: 205,
   partialContent: 206,
   badRequest: 400,
   unauthorized: 401,
   paymentRequired: 402,
   forbidden: 403,
   notFound: 404,
   methodNotAllowed: 405,
   notAcceptable: 406,
   proxyAuthenticateRequired: 407,
   requestTimeout: 408,
   conflict: 409,
   gone: 410,
   lengthRequired: 411,
   preconditionFailed: 412,
   payloadTooLarge: 413,
   uriTooLong: 414,
   unsupportedMediaType: 415,
   rangeNotSatisfiable: 416,
   expectationFailed: 417,
   pageExpired: 419,
   methodFailure: 420,
   misdirectedRequest: 421,
   unprocessableEntity: 422,
   locked: 423,
   failedDependency: 424,
   tooEarly: 425,
   upgradeRequired: 426,
   preconditionRequired: 428,
   tooManyRequests: 429,
   unavailableForLegalReasons: 451,
   internalError: 500,
   notImplemented: 501,
   badGateway: 502,
   serviceUnavailable: 503,
   gatewayTimeout: 504,
   insufficientStorage: 507,
};
